<template>
  <el-table-column
    prop="document_type.name"
    sortable="custom"
    label="Irattípus"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      {{ scope.row.document_type && scope.row.document_type.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'document_type.name',
  };
</script>
